

export interface LicensedFeatures {
    dataCompression: boolean;
}
